export {Box, Text, useInput, useStdin, Static} from 'ink'
